import { render, staticRenderFns } from "./ReceptionDataFormatter.vue?vue&type=template&id=718340f4&functional=true"
import script from "./ReceptionDataFormatter.vue?vue&type=script&lang=js"
export * from "./ReceptionDataFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports